'use client';

import { usePathname } from 'next/navigation';
import PublicNavigation from './PublicNavigation';

export default function ConditionalNavigation() {
  const pathname = usePathname();
  
  // Hide navigation on admin pages (but show on admin-login)
  const isAdminPage = pathname?.startsWith('/admin-') && pathname !== '/admin-login';
  
  if (isAdminPage) {
    return null;
  }
  
  return <PublicNavigation data-component-id="src/components/common/ConditionalNavigation.tsx:16:9" data-component-path="src/components/common/ConditionalNavigation.tsx" data-component-line="16" data-component-end-line="16" data-component-file="ConditionalNavigation.tsx" data-component-name="PublicNavigation" data-component-content="%7B%22elementName%22%3A%22PublicNavigation%22%7D" />;
}










